import modalMissProgMain from "./modalMissProgMain";
import modalMissProgProgram from "./modalMissProgProgram";
import getPageName from "../getPageName";
import getDataProgram from './getDataProgram';

async function initDropDownsPrograms(requestPrograms, CITIES) {
  const url = location.href.split("/");

  let filterNoDublicatePrograms = [],
    filterPrograms = [],
    level = "",
    city = "",
    region = "",
    allProgramsRegionFiltred = [],
    Program = document.getElementById(`Program`),
    City = document.getElementById(`City`),
    ProgramsHidden = document.querySelectorAll(".program-hidden"),
    Education = document.getElementById(`education-level`),
    Regions = document.getElementById(`Regions`),
    submitButton = document.getElementById(`form-btn`),
    formCheckbox = document.querySelector(`.form__checkboxs`),
    shortUrl = getPageName();

  /* Общий уникальный массив с операторами */
  let allPrograms = requestPrograms; 

  /* Список городов, доступный для данного региона */
  let cities = [];

  /* Выбор региона и программ в зависимости от региона */
  if (Regions !== null) {
    Regions.onchange = function (e) {
      region = e.target.value;

      /* Фильтрация общего массива в зависимости от выбранного региона */
      allProgramsRegionFiltred = allPrograms.filter((item) =>
        item.regions.some((it) => it.region_id == region)
      );

      /* Клонирование списка программ */
      let programsDublicate = structuredClone(allProgramsRegionFiltred);
     
      /* Обнуление списка городов и программ */
      cities = [];
      filterNoDublicatePrograms = [];
      city = "";
      
      /* Логика по добавлению списка городов, доступных в данном регионе и списка программ */

      // Формирование массива городов для конкретной страницы программы
      if (url.includes("program")){
        programsDublicate = programsDublicate.filter(item => item.shortname == shortUrl);
      }
   
      programsDublicate.forEach((i) => {
        i.regions.forEach((j) => {
          if (j.region_id == region) {
            filterNoDublicatePrograms.push(i);  
            j.cities.forEach((k) => {
              cities.push(k);
            });
          }
        });
      });

      cities = cities.filter((item, index) => cities.indexOf(item) === index);
      
      /* Сценарии вывода программ для страниц с полем Выбора программы и без него */
      if (!ProgramsHidden.length) {
        logicEducationFields();
        [...Program.children].map((item, idx) => {
          if (idx > 0) {
            item.remove();
          }
        });
      } else {
        logicEducationFields();
        setAttrforSingleField();
        logicModalPageProgram();
      }

      /* Создаем option только на главной для поля Город */
      renderOptions(cities, "City");
    };
  }

  /* Выбор уровня образования */
  if (Education !== null) {
    Education.onchange = function (e) {
      $(`#Program`).val(null).trigger("change");
      level = e.target.value;

      logicEducationFields();
      logicModalPageProgram();
    };
  }

  /* Выбор уровня образования */
  if (City !== null) {
    City.onchange = function (e) {
      $(`#Program`).val(null).trigger("change");
      city = e.target.value;

      logicEducationFields();
      logicModalPageProgram();
    };
  }
  
  /* Выбор программы. Получаем ссылку на РВР и устанавливаем ее в качестве аттрибута */
  if (!ProgramsHidden.length && Program) { 
    Program.onchange = function (e) {
      let data = getDataProgram(filterNoDublicatePrograms, e, region);
      
      /* Добавление аттрибута ссылки на РВР */
      e.target.options[e.target.selectedIndex].setAttribute(
        'linkrvr', data?.link
      );
      
      /* Добавление аттрибута оператора */
      e.target.options[e.target.selectedIndex].setAttribute(
        'operator', data?.operator
      );
      
      /* Добавление аттрибута id программы */
      e.target.options[e.target.selectedIndex].setAttribute(
        'program_id', data?.program_id
      );
    };
  }

  /* Логика вывода модальных окон на странице программы */
  function logicModalPageProgram() {
    /* Если не сайт программы, прекращаем выполнение функции */
    if (!url.includes("program")) {
      return;
    }

    if (region && level) {
      let statusPO = false,
        statusDPO = false;

      filterNoDublicatePrograms.forEach((program) => {
        if (program.shortname == shortUrl) {
          statusPO = true;
        }
      });

      filterPrograms.forEach((program) => {
        if (program.shortname == shortUrl) {
          statusDPO = true;
        }
      });

      /* Модальное окно отсутствия программ по выбранному региону для страниц программ */
      modalMissProgProgram(
        filterNoDublicatePrograms,
        region,
        submitButton,
        formCheckbox,
        shortUrl,
        [statusPO, statusDPO],
        city
      );
    }
  }

  /* Логика полей в зависимости от выбора уровня образования */
  function logicEducationFields() {
    let searchCityProgram = [];

    if (level == 1) {
      searchCityProgram = filterNoDublicatePrograms.filter((item) => item.level == "vocational");
    } else {
      searchCityProgram = filterNoDublicatePrograms;
    }

    if (city == "") {
      filterPrograms = searchCityProgram;
    } else {
      filterPrograms = [];

      searchCityProgram.forEach((i) => {
        i.regions.forEach((j) => {
          if (j.region_id == region) {
            j.cities.forEach((k) => {
              if (k == city) {
                filterPrograms.push(i);
              }
            });
          }
        });
      });
    }

    filterPrograms = filterPrograms.filter(
      (item, idx, filterPrograms) =>
        filterPrograms.findIndex((el) => el.shortname === item.shortname) == idx
    );

    if (!url.includes("program")) {
      /* Создаем option только на главной для поля Программы */
      renderOptions(filterPrograms, "Program");
    }
    
    if (!ProgramsHidden.length) {
      /* Модальное окно отсутствия программ по выбранному региону для главной страницы */
      modalMissProgMain(
        Regions,
        filterPrograms,
        filterNoDublicatePrograms
      );
    }
  }

  /* Создаем нужные options */
  function renderOptions(arr, field) {
    if (field == "City") {
      [...City.children].map((item, idx) => {
        if (idx > 0) {
          item.remove();
        }
      });

      let list_cities = CITIES.filter(e => cities.includes(e.id));

      list_cities.forEach((item) => {
        let option = new Option(item.name, item.id, false, false);
        City.append(option);
      });
    } else {
      [...Program.children].map((item, idx) => {
        if (idx > 0) {
          item.remove();
        }
      });

      arr.forEach((item) => {
        let option = new Option(item.name, item.name, false, false);
        option.setAttribute("shortname", item.shortname);

        Program.append(option);
      });
    }
  }

  /* Если страница программы, добавляем необходимые аттрибуты к скрытым полям */
  function setAttrforSingleField() {
    ProgramsHidden.forEach((programHidden) => {
      programHidden.setAttribute("shortname", shortUrl);
      
      let data = getDataProgram(filterNoDublicatePrograms, programHidden, region);
      
      programHidden.setAttribute(
        'linkrvr', data?.link
      );
      programHidden.setAttribute(
        'operator', data?.operator
      );
      programHidden.setAttribute(
        'program_id', data?.program_id
      );
    });
  }
}

export default initDropDownsPrograms;
